window.addEventListener('DOMContentLoaded', function() {
    ( function( $ ) {
        
        var portfolioSectorSlickSettings = {
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2750,
            infinite: false,
            slidesToShow: 1,
            pauseOnHover: true,
            fade: false,
            cssEase: 'linear',
            speed: 750,
            mobileFirst: true,
            responsive:[{
                    breakpoint:767,
                    settings: "unslick"
            }]
        };
        
        var awardsSlickSettings = {
            dots: true,
            slide: 'li',
            arrows: false,
            autoplay: false,
            autoplaySpeed: 2750,
            infinite: false,
            slidesToShow: 2,
            pauseOnHover: true,
            fade: false,
            cssEase: 'linear',
            speed: 750,
            mobileFirst: true,
            responsive:[{
                    breakpoint:767,
                    settings: "unslick"
            }]
        };

        var sl = "";
        var awardSL = "";
        
        var vid = document.getElementById("veloVideo");
        var videoTrackingOnce = false;
        var fadeTextOnce = true;

        var target = document.querySelector('#aboutUsTarget');
        var results = Splitting({ target: target, by: 'words' });

        $.fn.isInViewport = function() {
            var elementTop = $(this).offset().top;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        function msieversion() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE 10");

            if (msie > 0){
                $("[data-aos^=fade][data-aos^=fade]").css("opacity", "1");        
            }else{
                AOS.init();
            }

        }

        $(document).ready(function () {        

            msieversion();

            // Swap the nav elements to alternative 'white' mode.
            if($('.mainNav').hasClass('scrolled')){        
                $('#nav').removeClass('altNav');
                $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
            }else{
                $('#nav').addClass('altNav');
                $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
            }

            $('body').on('click', '.hamburger', function () {

               if($('.mainNav').hasClass('hamburgerActive')){        
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
                }else{
                    if(!$('.mainNav').hasClass('scrolled')){ 
                        $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
                    }
                } 

            });

            setHeightCarousel();
            setHeightPortfolioSectors();

            $(window).bind('resizeEnd', function () {

                setHeightCarousel();  
                setHeightPortfolioSectors();

            });                                      
            
            $('.home-carousel').on('init', function(){
                $('#rotateThis, #sliderParent').removeClass().addClass('slide0');
            });

            $('.home-carousel').slick({
                dots: true,
                autoplay: false,
                autoplaySpeed: 5000,
                infinite: false,
                slidesToShow: 3.5,
                fade: false,
                cssEase: 'ease-in-out',
                speed: 1000,
                slide: '.altCarouselItem',
                nextArrow: '<div class="prevAnimate"><span></span><span></span></div>', //fake this prevAnimate arrow as the next arrow!
                responsive: [{
                    breakpoint: 767, // mobile breakpoint
                    settings: {
                        slidesToShow: 1.5,
                        nextArrow: '<div class="prevAnimate"><span></span><span></span></div>'
                    }
                },
                {
                    breakpoint: 480, // mobile breakpoint
                    settings: {
                        slidesToShow: 1.1,
                        nextArrow: '<div class="prevAnimate"><span></span><span></span></div>'
                    }
                }]
            });            

            var sl = $('.portfolioSectorMobileCarousel').slick(portfolioSectorSlickSettings);
            
            $('.awardListingList').on('init', function(event, slick){
                $( '.awardMobileCarousel' ).show();
            });
            
            var awardSL = $('.awardListingList').slick(awardsSlickSettings);                        
            
            // Assign an ontimeupdate event to the <video> element, and execute a function if the current playback position has changed
            vid.ontimeupdate = function() {videoTimestampTracking();};

        });            

        /**
         * WINDOW ON SCROLL
         */
        $( window ).scroll(function() {

            setTimeout(function(){
                if($('.mainNav').hasClass('scrolled')){        
                    $('#nav').removeClass('altNav');
                    $('.logo img').attr('src', '/wp-content/themes/velo/img/velo-home-logo.png');
                }else{
                    //if($(window).scrollTop() > 20) {
                        $('#nav').addClass('altNav');
                        $('.logo img').attr('src', '/wp-content/themes/velo/img/velo_white.png');
                    //}
                }
            }, 200);

            //console.log($("html").scrollTop());

            if ($('#aboutUsTarget').isInViewport()) {     
                triggerCharacters();
            }

        });

        /**
         * WINDOW ON RESIZE
         */
        $( window ).on('resize', function(){

            AOS.refresh();

            if( $( window ).width() < 768 && !$('.portfolioSectorMobileCarousel').hasClass('slick-initialized')){
                $('.portfolioSectorMobileCarousel').slick(portfolioSectorSlickSettings);
            }
            
            if( $( window ).width() < 768 && !$('.awardListingList').hasClass('slick-initialized')){
                $('.awardListingList').slick(awardsSlickSettings);
                
                $( '.awardMobileCarousel' ).show();
            }

        });

        /**
         * WINDOW ON LOAD
         */
        $( window ).on('load', function() {

            setTimeout(AOS.refreshHard, 150);

            $('.voiceCardContainer').masonry({            
                columnWidth: '.gridSizer',            
                gutter: '.gutterSizer',
                itemSelector: '.voiceCard',
                percentPosition: true
            });

        });

        // Go through a sentence and trigger activate state
        function triggerCharacters() {

            var sentenceCounter = 0;
            var sentenceDelay = 150;

            if(fadeTextOnce){

                $('#aboutUsTarget').each(function() {

                    var $sentence = $(this);

                    // Trigger for each sentence
                    setTimeout(function() {
                        var $spans = $sentence.find('span');
                        var spanCounter = 0;
                        var spanDelay = 30;

                        // Loop through all spans and activate
                        $spans.each(function() {
                            var $span = $(this);

                            // Trigger a timeout so each span is offset
                            setTimeout(function() {
                                $span.toggleClass('active');
                            }, (spanCounter * spanDelay));

                            spanCounter++; 
                        });

                    }, (sentenceCounter * sentenceDelay));

                    sentenceCounter++;

                });

                fadeTextOnce = false;

            }
        }

        function setHeightCarousel(){

            $('.videoHeight').css('height', 'inherit');

            var getVideoContainerHeight = $('.videoContainer').height();

            $('.videoHeight').css('height', '' + (getVideoContainerHeight + 20) + 'px');

        }

        function setHeightPortfolioSectors(){

            $('.portfolioInner').css('height', 'inherit');

            var setHeight = 0;

            $('.portfolioSector').each(function(){

                if($(this).height() > setHeight){setHeight = $(this).height();}

            });

            $('.portfolioInner').css('height', (setHeight+10) + 'px');

        }

        function videoTimestampTracking() {

            var currentVidTime = vid.currentTime;

            /* Determine which sector block to show based on the time stamps of the video:
             * 0 - 3 seconds = Buildings sector
             * 4 - 6 seconds = Technology sector
             * 7 - 9 seconds = Industrial sector
             * 10 - 12 seconds = Professional services
             * > 12 = Main text appears
             */

            if(videoTrackingOnce == false){

                if(currentVidTime >= 0 && currentVidTime < 3){
                    $('.portfolioBlock-building-sector').removeClass('portfolioSectorHide');
                    $('.portfolioBlock-building-sector').addClass('animateWidth');
                }

                if(currentVidTime >= 3 && currentVidTime <= 6){            
                    $('.portfolioBlock-building-sector').addClass('portfolioSectorHide');
                    $('.portfolioBlock-building-sector').removeClass('animateWidth');
                    $('.portfolioBlock-technology-sector').removeClass('portfolioSectorHide');
                    $('.portfolioBlock-technology-sector').addClass('animateWidth');
                }

                if(currentVidTime > 6 && currentVidTime <= 9){

                    $('.portfolioBlock-building-sector').addClass('portfolioSectorHide');
                    $('.portfolioBlock-building-sector').removeClass('animateWidth');

                    $('.portfolioBlock-technology-sector').addClass('portfolioSectorHide');
                    $('.portfolioBlock-technology-sector').removeClass('animateWidth');

                    $('.portfolioBlock-industrial-sector').removeClass('portfolioSectorHide');
                    $('.portfolioBlock-industrial-sector').addClass('animateWidth');
                }

                if(currentVidTime > 9 && currentVidTime <= 12){

                    $('.portfolioBlock-building-sector').addClass('portfolioSectorHide');
                    $('.portfolioBlock-building-sector').removeClass('animateWidth');

                    $('.portfolioBlock-technology-sector').addClass('portfolioSectorHide');
                    $('.portfolioBlock-technology-sector').removeClass('animateWidth');

                    $('.portfolioBlock-industrial-sector').addClass('portfolioSectorHide');
                    $('.portfolioBlock-industrial-sector').removeClass('animateWidth');

                    $('.portfolioBlock-professional-services').removeClass('portfolioSectorHide');
                    $('.portfolioBlock-professional-services').addClass('animateWidth');

                }

                if(currentVidTime >= 12){

                    $('.portfolioBlock-professional-services').removeClass('animateWidth');

                    $('.heroTitle').removeClass('hideHeroTitle');

                    setTimeout(function(){

                        $('.portfolioBlock-building-sector').removeClass('portfolioSectorHide');
                        $('.portfolioBlock-building-sector').addClass('animateWidth');

                        $('.portfolioBlock-technology-sector').removeClass('portfolioSectorHide');
                        $('.portfolioBlock-technology-sector').addClass('animateWidth');

                        $('.portfolioBlock-industrial-sector').removeClass('portfolioSectorHide');
                        $('.portfolioBlock-industrial-sector').addClass('animateWidth');

                        $('.portfolioBlock-professional-services').removeClass('portfolioSectorHide');
                        $('.portfolioBlock-professional-services').addClass('animateWidth');

                    }, 250);

                    videoTrackingOnce = true; //stop the remove/add class actions from happening again!
                }

            }    

        }

    } )( jQuery );
});